import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MdbModalRef } from 'src/lib/mdb5-adapted/public-api';
import { MdbRippleModule } from 'src/lib/mdb5-adapted/public-api';
import { map } from 'rxjs';
import { environment } from 'src/environments/environment';

import { LmsModalFrameComponent } from '../../ui/lms-modal-frame/lms-modal-frame.component';
import { AppUtilityService } from 'src/app/app-utility.service';

import { QuoteModel } from '@lmsModels';
import { PageCardheadComponent } from '@lmsSharedUI';

@Component({
  selector: 'app-lt-approval-dialog',
  templateUrl: './lt-approval-dialog.component.html',
  styleUrls: ['./lt-approval-dialog.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, PageCardheadComponent]
})
export class LtApprovalDialogComponent implements OnInit, OnDestroy {
  @Input() clientType: 'salaried' | 'pensioner' = 'salaried';
  @Input() loanAmount: number = 0;
  @Input() quoteData: QuoteModel | null = null;

  selectedApprovalType: 'BM' | 'AM' | 'RM' | null = null;
  isProcessing: boolean = false;

  constructor(
    private global_utility: AppUtilityService,
    private modalRef: MdbModalRef<LtApprovalDialogComponent>
  ) {}

  ngOnInit(): void {
    // For pensioner clients, auto-select RM
    if (this.clientType === 'pensioner') {
      this.selectedApprovalType = 'RM';
    }
  }

  getPageName(): string {
    return 'LT Loan Approval Required';
  }

  onApprovalTypeChange(type: 'BM' | 'AM' | 'RM'): void {
    this.selectedApprovalType = type;
  }

  onSubmit(): void {
    if (!this.selectedApprovalType) {
      this.global_utility.warning('Please select an approval type', 'Selection Required');
      return;
    }

    this.isProcessing = true;

    // For BM, handle biometric verification in quote component
    // For AM/RM, just return the selection
    this.closeWithResult({
      approvalType: this.selectedApprovalType,
      timestamp: new Date()
    });
  }

  onCancel(): void {
    this.close();
  }

  private closeWithResult(result: any): void {
    this.modalRef.close(result);
  }

  close(): void {
    this.modalRef.close(null);
  }

  ngOnDestroy(): void {
    // Cleanup if needed
  }
}
